import * as React from "react";

import "./suggested-comments-modal.scss";

import {cs}                     from "../../react/chain-services";
import {UseState}               from "../../react/use-state";
import {ModalService3}          from "../modal-service-3/modal-service-3";

export const SuggestedCommentsModal = ({next: rootNext, suggestedComments, setFieldVal, userData, maxChars = null}) => cs(
    ["state", (_, next) => UseState({
        getInitValue: () => ({displayedTab: 1, page: 1, limit:5}),
        next,
    })],
    ["modal", ({}, next) => ModalService3({
        next: ({close}) => next({close}),
        xToClose: true,
        ignorePassiveClose: true,
        rootNext,
        contentClassName: 'suggested-comments-74b',
        xdQaName: "SuggestedCommentsModal",
    })],
    ({modal, state}) => {
        let categoriesSet = new Set();
        let categories = [];
        let tabs = [];
        Object.keys(suggestedComments['Any']).forEach((key)=>{
            let com = suggestedComments['Any'][key];
            if(!categoriesSet.has(com.idCommentCategory)) {
                categories.push({id_primary: com.idCommentCategory, name: com.name});
                tabs[com.idCommentCategory] = [];
            }
            tabs[com.idCommentCategory].push(com);
            categoriesSet.add(com.idCommentCategory);
        });
        // TODO: Page buttons & skip page functionality is behaving weirdly (this is not new behavior)
        // sometimes one page is replaced by the "-" sometimes multiple. This is causing pg nav to shift around
        let pageButtons = [];
        let skipPage = <button className="page-nav" disabled={true} xd-qa-type="button" xd-qa-name="-">-</button>;
        let pageCount = Math.ceil(tabs[state.value.displayedTab]?.length / parseInt(state.value.limit));
        for(let i=0; i < pageCount; i++) {
            if(i === 0 || i === pageCount - 1 || (i+1 >= state.value.page-1 && i+1 <= state.value.page+1))
                pageButtons.push((<button
                                    className="page-nav"
                                    id={state.value.page === i+1 ? "selected" : ""}
                                    onClick={()=>{state.onChange({...state.value, page: i+1})}}
                                    xd-qa-type="button"
                                    xd-qa-name={i+1}
                                >
                                    {i+1}
                                </button>));
            else if(i === 1 || i === pageCount - 2)
                pageButtons.push(skipPage);
        }
        function compare(a, b) {
            if (a.id_primary > b.id_primary) return 1;
            if (b.id_primary > a.id_primary) return -1;
            return 0;
        }
        categories.sort(compare);
        if(!categoriesSet.has(state.value.displayedTab)) {
            state.onChange({...state.value, displayedTab: categories[0].id_primary});
        }
        let showingStart = (state.value.page - 1) * state.value.limit + 1;
        let showingEnd = (state.value.page - 1) * state.value.limit + parseInt(state.value.limit);
        showingEnd = showingEnd > tabs[state.value.displayedTab]?.length ? tabs[state.value.displayedTab]?.length : showingEnd;
        return(
            <div className="suggested-comments-32a" xd-qa-type="modal" xd-qa-name="Suggested Comments Modal">
                <div className="header">
                    <div>
                        <div className="title" xd-qa-type="label" xd-qa-name="Suggested Comments">
                            Suggested Comments
                        </div>
                        <div className="cat-nav">
                            {Object.keys(categories).length > 1 ? <button className="fa fa-chevron-left  page-nav left"  {...{onClick: ()=>{document.querySelector('.categories-header').scroll({left:document.querySelector('.categories-header').scrollLeft-210,behavior:'smooth'})} }}/> : ''}
                            {Object.keys(categories).length > 1 ? <button className="fa fa-chevron-right page-nav right" {...{onClick: ()=>{document.querySelector('.categories-header').scroll({left:document.querySelector('.categories-header').scrollLeft+210,behavior:'smooth'})} }}/> : ''}
                        </div>
                    </div>
                </div>

                <div className="categories-header">
                    {Object.keys(categories).length > 1 ? categories.map((category, index)=>{
                        return <div className={category.id_primary === state.value.displayedTab ? "category active" : "category inactive"} id={index+1+''}
                        onClick={()=>{
                            document.querySelectorAll('.category').forEach((elt)=>{elt.className='category inactive'});
                            state.onChange({...state.value, page: 1, displayedTab: category.id_primary});
                            document.querySelector('.category[id="'+category.id_primary+'"]').className='category active'
                        }}>{category.name}</div>}) : ''}
                </div>
                <div className="content">
                    <header className="content-header">Select a comment to pull into your order</header>
                    <div className="content-text">The comment you choose will replace any text that is already customized in the selected field of your order. After selecting and saving from this screen you will still be able to edit the comment on the customization screen.</div>
                    <br/>
                    <div id="selections">
                        <div id="selection">
                        {tabs[state.value.displayedTab]?.map((elm, index)=>{
                            let comment = elm['comments'];
                            if(index < (state.value.page-1)*state.value.limit || index >= ((state.value.page-1)*state.value.limit)+parseInt(state.value.limit))
                                return;
                            let inputIndex=0;
                            let placeholders = Array.from(comment.matchAll(/\(MUST TYPE(?: IN)?(.+?)HERE\)/gi));
                            comment = comment.replaceAll(/\(MUST TYPE(?: IN)?(.+?)HERE\)/gi, ()=>{return '<input placeholder="' + placeholders[inputIndex][1] + '" xd-qa-type="text_field" xd-qa-name="' + placeholders[inputIndex][1].trim() + '" id="' + inputIndex++ + '"></input>'});
                            comment = comment.replaceAll(/COMPANY_NAME/gi, userData.sourceData.xd.company.companyName);
                            const plainTextComment = comment.replaceAll(/<.*?>/g, '');
                            return (
                                <div className="selectable-comment" key={index} xd-qa-type="card" xd-qa-name={"Suggestion " + index}>
                                    {(maxChars && maxChars < plainTextComment.length) ? <em><p className="text-danger"><strong>Note</strong>: This comment exceeds the {maxChars} character limit for this field and will be truncated.</p></em> : null}
                                    <input type="radio" name='radio' value={'suggested'+index} xd-qa-type="radio" xd-qa-name="Radio Suggestion"></input>
                                    <div id={'suggested'+index} className="comment-text" dangerouslySetInnerHTML={{__html: comment}} xd-qa-type="text" xd-qa-name="Suggestion Text"/>
                                </div>
                            )
                        })}
                        </div>
                    </div>
                    <div className="nav-container">
                        <div className="limit-select">
                            <select onChange={()=>{state.onChange({...state.value, limit: event.target.value, page: 1})}} value={state.value.limit} xd-qa-type="dropdown" xd-qa-name="Page Number">
                                <option value="5" xd-qa-type="dropdown_item" xd-qa-name="5">5</option>
                                <option value="10" xd-qa-type="dropdown_item" xd-qa-name="10">10</option>
                                <option value="15" xd-qa-type="dropdown_item" xd-qa-name="15">15</option>
                                <option value="20" xd-qa-type="dropdown_item" xd-qa-name="20">20</option>
                            </select>
                            <div className="mobile-hide" xd-qa-type="label" xd-qa-name="Results per page">Results per page</div>
                        </div>
                        <div className="page-select">
                            <button
                                className="fa fa-chevron-left page-nav left"
                                // aria-disabled prevents the blur event that comes with disabled. Blur event causes FieldOptions frame to close
                                aria-disabled={state.value.page === 1}
                                onClick={()=>{
                                    state.value.page === 1 ?
                                        null :
                                            state.onChange({...state.value, page: state.value.page-1});
                                }}
                                xd-qa-type="button"
                                xd-qa-name="Left"
                            />
                                {pageButtons}
                            <button
                                className="fa fa-chevron-right page-nav right"
                                // aria-disabled prevents the blur event that comes with disabled. Blur event causes FieldOptions frame to close
                                aria-disabled={!(state.value.page * state.value.limit < tabs[state.value.displayedTab]?.length)}
                                onClick={()=>{
                                    !(state.value.page * state.value.limit < tabs[state.value.displayedTab]?.length) ?
                                        null :
                                            state.onChange({...state.value, page: state.value.page+1});
                                }}
                                xd-qa-type="button"
                                xd-qa-name="Right"
                            />
                        </div>
                        <div className='page-count mobile-hide'>
                            Showing {showingStart} - {showingEnd} of {tabs[state.value.displayedTab]?.length} suggestions
                        </div>
                    </div>
                </div>

                <div className="footer">
                    <button {...{
                        className: "save",
                        onClick: ()=>{
                            if(!document.querySelector("input[name='radio']:checked"))
                                return;
                            let elt = document.querySelector('[id='+document.querySelector("input[name='radio']:checked").value+']');
                            let inner = elt.innerHTML;
                            let inputs = elt.querySelectorAll('input');
                            inputs.forEach((input, index)=>{
                                inner = inner.replace(new RegExp('<input placeholder="([^"]*)" xd-qa-type="([^"]*)" xd-qa-name="([^"]*)" id="' + index + '">', 'i'), input.value);
                                if(input.value)
                                {
                                    inner = inner.replace(new RegExp('<input placeholder="([^"]*)" xd-qa-type="([^"]*)" xd-qa-name="([^"]*)" id="' + index + '" data-gtm-form-interact-field-id="([^"]*)">', 'i'), input.value);
                                }
                            });

                            setFieldVal(inner);
                            modal.close();
                        },
                    }}
                        xd-qa-type="button"
                        xd-qa-name="Save"
                    >
                        Save
                    </button>
                    <button {...{
                        className: "cancel",
                        onClick: modal.close,
                    }}
                        xd-qa-type="button"
                        xd-qa-name="Cancel"
                    >
                        Cancel
                    </button>
                </div>
            </div>
        )
    }
);